<template>
  <div>
    <v-dialog v-model="dialog" width="600px">
      <template v-slot:activator="{ on, attrs }">
        <v-btn color="primary" dark v-bind="attrs" v-on="on"> Buy </v-btn>
      </template>

      <v-card>
        <div class="header d-flex justify-space-between align-center primary white--text px-3">
          <v-card-title class="white--text">
            <span> Buy Licences</span>
          </v-card-title>
          <v-btn @click="dialog = false" icon color="white"><v-icon>mdi-close</v-icon></v-btn>
        </div>
        <v-card-text>
          <div class="d-flex flex-row align-center">
            <div class="text-center mt-8">
              <v-text-field
                class="centered-input"
                style="zoom: 200%; width: 100px"
                v-model="licenses"
                label="Licenses"
                :hint="`$${amount} Total`"
                persistent-hint
              >
              </v-text-field>
            </div>
            <div class="ml-5">
              <div class="font-weight-bold">Licencing Plan:</div>
              <div>${{ companyRate }} per traveler per trip</div>
              <div>* No fee is charged when company administrator join trips</div>
              <div>
                * For trip admins that are not company admins, a licence will be consumed when they
                join a trip
              </div>
            </div>
          </div>
          <h4 class="my-4">Choose payment method</h4>
          <v-row>
            <v-col v-for="method in savedMethods" :key="method.id" cols="6">
              <v-card
                height="140px"
                :class="`${method.selected ? 'primary' : ''}`"
                :dark="method.selected"
                @click="selectPM(method.id)"
              >
                <!-- <v-card-title>{{ method.card.brand }}</v-card-title> -->
                <div class="pt-2">
                  <v-img
                    class="mr-3"
                    style="display: block; margin-left: auto"
                    v-if="method.card.brand == 'visa'"
                    width="60"
                    contain
                    :src="require('@/assets/visa.png')"
                  ></v-img>
                  <v-img
                    class="mr-3"
                    style="display: block; margin-left: auto"
                    v-else-if="method.card.brand == 'mastercard'"
                    width="60"
                    :src="require('@/assets/mastercard.png')"
                  ></v-img>
                  <v-img
                    class="mr-3"
                    style="display: block; margin-left: auto"
                    v-else-if="method.card.brand == 'amex'"
                    width="56"
                    :src="require('@/assets/amex.png')"
                  ></v-img>
                </div>
                <v-card-title class="mt-1 pb-0 mb-0">
                  xxxx xxxx xxxx {{ method.card.last4 }}</v-card-title
                >
                <div class="mv-1 ml-4">
                  Exp: {{ method.card.exp_month }}/{{ method.card.exp_year }}
                </div>
              </v-card>
            </v-col>
            <v-col cols="6">
              <v-card
                :class="`ml-2 ${addCard ? 'primary' : ''}`"
                :dark="addCard"
                height="140px"
                @click="addNewPM"
              >
                <!-- <v-card-title class="">Add new card</v-card-title> -->
                <v-card-text class="text-center pt-9">
                  <v-icon :color="addCard ? 'white' : 'primary'" large
                    >mdi-plus-circle-outline</v-icon
                  >
                  <h4 class="mt-1">Add new card</h4>
                  <!-- <v-icon :color="addCard ? 'white' : 'primary'"
                 large>mdi-credit-card</v-icon> -->
                </v-card-text>
                <!-- <v-card-title> xxxx xxxx xxxx {{ method.card.last4 }}</v-card-title> -->
              </v-card>
            </v-col>
          </v-row>

          <v-card class="mt-4" v-if="addCard">
            <v-card-title>Add new card</v-card-title>
            <v-card-text>
              <v-text-field
                v-model="cardholder"
                solo
                flat
                placeholder="Cardholder Name"
              ></v-text-field>
              <stripe-element-card
                ref="elementRef"
                :pk="pulishableKey"
                @token="tokenCreated"
                :elementStyle="style"
              />
              <v-switch v-model="saveCard" label="Save for future use"></v-switch>
            </v-card-text>
          </v-card>
          <div v-if="feedback" class="error--text mt-2">
            {{ feedback }}
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :loading="loading" class="primary" @click="submit"
            >Buy {{ licenses }} licences</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar">
      <!-- {{ $t("common.tripSuccess") }} -->
      Payment completed
      <v-btn color="primary" text @click="snackbar = false">{{ $t("common.close") }}</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import { StripeElementCard } from "@vue-stripe/vue-stripe";
import functions from "@/firebase/functions";

export default {
  components: {
    StripeElementCard,
  },
  props: ["companyId"],
  data() {
    return {
      // eslint-disable-next-line no-underscore-dangle
      pulishableKey: this.$stripe._apiKey,
      dialog: false,
      licenses: 10,
      saveCard: true,
      loading: false,
      cardholder: "",
      addCard: true,
      snackbar: false,
      feedback: null,
      savedMethods: [],
      style: {},
    };
  },
  mounted() {
    this.getPaymentMethods();
  },
  computed: {
    amount() {
      if (Number.isNaN(parseFloat(this.licenses, 10))) {
        return NaN;
      }
      return parseFloat(this.licenses, 10) * this.companyRate;
    },
    companyRate() {
      return this.$store.state.companiesPrivate[this.$props.companyId].rate || 10;
    },
    email() {
      return this.$store.state.currentUser.email;
    },
  },
  methods: {
    addNewPM() {
      this.addCard = true;
      // eslint-disable-next-line no-restricted-syntax, guard-for-in
      for (const i in this.savedMethods) {
        this.$set(this.savedMethods[i], "selected", false);
      }
    },
    selectPM(selected) {
      // eslint-disable-next-line no-restricted-syntax, guard-for-in
      for (const i in this.savedMethods) {
        this.$set(this.savedMethods[i], "selected", this.savedMethods[i].id === selected);
      }

      this.addCard = false;
    },
    async getPaymentMethods() {
      try {
        const now = new Date();
        const result = await functions.call("customer-paymentMethods");
        this.savedMethods = result.data.filter((pm) => {
          const exp = new Date(pm.card.exp_year, pm.card.exp_month);
          return exp > now;
        });
        if (result.data && result.data.length > 0) {
          this.selectPM(result.data[0].id);
        }
      } catch (e) {
        console.log("error getting paymentmethods", e.message);
      }
    },
    submit() {
      if (Number.isNaN(this.amount)) {
        this.feedback = "Please enter a valid amount";
        return;
      }
      this.feedback = null;

      // this will trigger the process
      this.loading = true;
      if (this.addCard) {
        if (!this.cardholder) {
          this.feedback = "Please enter the cardholder's name";
          this.loading = false;
          return;
        }
        this.$refs.elementRef.submit();
      } else {
        const pm = this.savedMethods.find((c) => c.selected);
        this.payWithPM(pm.id);
      }
    },
    async tokenCreated(token) {
      console.log("token obtained", token);
      try {
        const result = await functions.createPaymentIntent(
          this.$props.companyId,
          this.amount,
          this.saveCard,
        );
        console.log("createPaymentIntent, obtained", result);
        this.payWithCard(
          {
            card: { token: token.id },
            billing_details: {
              name: this.cardholder,
            },
          },
          result.data,
        );
      } catch (error) {
        console.log("catch error", error);
        this.loading = false;
      }
    },
    async payWithPM(pm) {
      try {
        const result = await functions.createPaymentIntent(
          this.$props.companyId,
          this.amount,
          false,
          pm,
        );

        console.log(result);
        this.payWithCard(null, result.data);
      } catch (error) {
        console.log(error);
        this.feedback = error;
        this.loading = false;
      }
    },
    payWithCard(paymentMethod, clientSecret) {
      const data = {
        receipt_email: this.email,
      };
      if (paymentMethod) {
        data.payment_method = paymentMethod;
      }
      this.$stripe.confirmCardPayment(clientSecret, data).then((result) => {
        this.loading = false;
        console.log(result);
        if (result.error) {
          this.feedback = result.error.message;
          // Show error to your customer
          // showError(result.error.message);
        } else {
          this.snackbar = true;
          this.dialog = false;
          if (this.saveCard) {
            this.getPaymentMethods();
          }
          // The payment succeeded!
          // orderComplete(result.paymentIntent.id);
        }
      });
    },
  },
};
</script>

<style>
#amountfield {
  transform: scale(2);
  transform-origin: center;
}

.centered-input input {
  text-align: center;
}
</style>
